import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createTemplate, updateTemplate, deleteTemplate } from '../../store/thunks/templatesActions';

export default function TemplateModal({ onClose, initial }) {
  const dispatch = useDispatch();
  const [name, setName] = useState(initial?.name || '');
  const [subject, setSubject] = useState(initial?.subject || '');
  const [html, setHtml] = useState(initial?.html || '');

  const handleSave = () => {
    if (initial) {
      dispatch(updateTemplate({ _id: initial._id, name, subject, html }));
    } else {
      dispatch(createTemplate({ name, subject, html }));
    }
    onClose();
  };

  const handleDelete = () => {
    if (initial) {
      dispatch(deleteTemplate(initial._id));
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-[16px] shadow-md w-[600px]">
        <h3 className="text-xl font-semibold mb-4 text-[#1F2937]">
          {initial ? 'Edit Template' : 'New Template'}
        </h3>
        <div className="mb-4">
          <label className="text-sm font-medium text-[#374151]">Name</label>
          <input
            type="text"
            className="w-full p-2 border rounded-[12px] text-[#1F2937]"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label className="text-sm font-medium text-[#374151]">Subject</label>
          <input
            type="text"
            className="w-full p-2 border rounded-[12px] text-[#1F2937]"
            value={subject}
            onChange={e => setSubject(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label className="text-sm font-medium text-[#374151]">Body (HTML)</label>
          <textarea
            className="w-full p-2 border rounded-[12px] text-[#1F2937] h-[150px]"
            value={html}
            onChange={e => setHtml(e.target.value)}
          />
        </div>
        <div className="flex justify-end gap-4 mt-6">
          <button
            className="px-4 py-2 rounded-[12px] border"
            style={{ borderColor: '#D1D5DB', color: '#374151' }}
            onClick={onClose}
          >
            Cancel
          </button>
          {initial && (
            <button
              className="px-4 py-2 rounded-[12px] border"
              style={{ borderColor: '#EF4444', color: '#EF4444' }}
              onClick={handleDelete}
            >
              Delete
            </button>
          )}
          <button
            className="px-4 py-2 rounded-[12px]" 
            style={{ backgroundColor: '#2563EB', color: '#FFFFFF' }} 
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}